import { render, staticRenderFns } from "./VehicleMakeChart.vue?vue&type=template&id=3cca0385&scoped=true"
import script from "./VehicleMakeChart.vue?vue&type=script&lang=ts"
export * from "./VehicleMakeChart.vue?vue&type=script&lang=ts"
import style0 from "./VehicleMakeChart.vue?vue&type=style&index=0&id=3cca0385&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca0385",
  null
  
)

export default component.exports